/**
 * @file 管理平台下线迁移文案
 * @author sunyingying01
 */

/** 通用按钮/链接文案 */
export const GO_TO_NEW_PLATFORM = '前往新平台';

/** 轻量通知期（D0~D7） */
export const NOTICE_TITLE = '伐谋管理平台已全面升级';
export const NOTICE_CONTENT = '新平台已上线，支持更强大的演化能力和 Agent 智能交付。您的历史实验将安全保存，可在新平台中继续。';

/** 受限运行期（D7~D30） */
export const RESTRICTED_CONTENT = '新实验请跳转至新平台创建。当前平台仅保留查看、下载功能，运行中的实验不受影响。';

/** 受限运行期标题：剩余天数动态展示 */
export function getRestrictedTitle(days: number): string {
    return `管理平台将于 ${days} 天后完成升级`;
}

/** 受限运行期通栏文案：标题 + 说明 */
export function getRestrictedBannerText(days: number): string {
    return `${getRestrictedTitle(days)}，${RESTRICTED_CONTENT}`;
}

/** 受限运行期，被禁用的新建/演化入口提示 */
export const RESTRICT_TIP = '新建功能已迁移，请跳转至新平台完成操作';
